// Cart Drawer functionality
class CartDrawer {
    constructor() {
        this.drawer = document.getElementById('CartDrawer');
        this.overlay = document.getElementById('CartDrawerOverlay');
        this.closeButtons = document.querySelectorAll('[data-drawer-close]');
        this.removalTimers = {}; // Track timers for auto-removal

        if (!this.drawer) return;

        this.bindEvents();
    }

    bindEvents() {
        // Close button clicks
        this.closeButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                this.close();
            });
        });

        // Quantity changes - use event delegation on the drawer itself
        this.drawer.addEventListener('click', (e) => {
            const plusButton = e.target.closest('.cart-drawer-quantity__button.plus');
            const minusButton = e.target.closest('.cart-drawer-quantity__button.minus');
            const removeButton = e.target.closest('.cart-drawer-quantity__remove-btn');

            if (plusButton) {
                e.preventDefault();
                const key = plusButton.dataset.key;
                if (key) {
                    this.changeQuantity(key, 1);
                }
            } else if (minusButton) {
                e.preventDefault();
                const key = minusButton.dataset.key;
                if (key) {
                    this.changeQuantity(key, -1);
                }
            } else if (removeButton) {
                e.preventDefault();
                const key = removeButton.dataset.key;
                if (key) {
                    this.removeItem(key);
                }
            }
        });

        // Watch for input changes to show/hide remove button
        this.drawer.addEventListener('input', (e) => {
            if (e.target.classList.contains('cart-drawer-quantity__input')) {
                this.toggleRemoveButton(e.target);
            }
        });

        // Listen for mouseleave on cart items to trigger auto-removal
        this.drawer.addEventListener('mouseleave', (e) => {
            // Check all inputs with quantity 0
            const zeroQtyInputs = this.drawer.querySelectorAll('.cart-drawer-quantity__input[value="0"]');
            zeroQtyInputs.forEach(input => {
                const key = input.dataset.key;
                if (key && !this.removalTimers[key]) {
                    // Start a 3-second timer to remove this item
                    this.removalTimers[key] = setTimeout(() => {
                        this.removeItem(key);
                        delete this.removalTimers[key];
                    }, 3000);
                }
            });
        });

        // Cancel removal timer if mouse enters back
        this.drawer.addEventListener('mouseenter', (e) => {
            // Clear all pending removal timers
            Object.keys(this.removalTimers).forEach(key => {
                clearTimeout(this.removalTimers[key]);
                delete this.removalTimers[key];
            });
        });

        // Listen for cart:toggle event
        document.addEventListener('cart:toggle', () => {
            if (this.drawer.classList.contains('active')) {
                this.close();
            } else {
                this.open();
            }
        });
    }

    open() {
        if (this.drawer) {
            this.drawer.classList.add('active');
            this.overlay.classList.add('active');
            document.body.style.overflow = 'hidden';
            this.refresh();
        }
    }

    close() {
        if (this.drawer) {
            this.drawer.classList.remove('active');
            this.overlay.classList.remove('active');
            document.body.style.overflow = '';

            // Clear any pending removal timers
            Object.keys(this.removalTimers).forEach(key => {
                clearTimeout(this.removalTimers[key]);
                delete this.removalTimers[key];
            });
        }
    }

    async refresh() {
        try {
            // Fetch current cart data from Shopify Cart API
            const response = await fetch('/cart.js');
            const cart = await response.json();


            // Update items section
            const itemsContainer = document.getElementById('CartDrawerItems');
            if (!itemsContainer) return;

            if (cart.item_count === 0) {
                // Show empty state
                itemsContainer.innerHTML = `
                    <div class="cart-drawer__empty-state">
                        <p>Your cart is empty.</p>
                        <a href="/collections/all" class="button button--secondary" style="margin-top:2rem;" data-drawer-close>Continue Shopping</a>
                    </div>
                `;
            } else {
                // Build items HTML
                let itemsHTML = '';
                cart.items.forEach(item => {
                    const variantTitle = item.variant_title !== 'Default Title' ? `<span class="cart-item__variant">${item.variant_title}</span>` : '';
                    itemsHTML += `
                        <div class="cart-item">
                            <div class="cart-item__image-container">
                                ${item.image ? `<img src="${item.image}" alt="${item.title}" class="cart-item__image" width="80" loading="lazy">` : ''}
                            </div>
                            <div class="cart-item__details">
                                <a href="${item.url}" class="cart-item__title">${item.product_title}</a>
                                ${variantTitle}
                                <div class="cart-item__price">${this.formatMoney(item.final_price)}</div>
                                <div class="cart-drawer-quantity">
                                    <button class="cart-drawer-quantity__button minus" data-key="${item.key}" aria-label="Decrease quantity">
                                        <svg width="10" height="2" viewBox="0 0 10 2" fill="currentColor"><rect width="10" height="2"/></svg>
                                    </button>
                                    <input class="cart-drawer-quantity__input" 
                                           type="number" 
                                           value="${item.quantity}" 
                                           data-key="${item.key}"
                                           id="Drawer-quantity-${item.key}"
                                           min="0"
                                           aria-label="Quantity">
                                    <button class="cart-drawer-quantity__button plus" data-key="${item.key}" aria-label="Increase quantity">
                                        <svg width="10" height="10" viewBox="0 0 10 10" fill="currentColor"><path d="M4 0h2v10H4z"/><path d="M0 4h10v2H0z"/></svg>
                                    </button>
                                    <button class="cart-drawer-quantity__remove-btn" 
                                            data-key="${item.key}" 
                                            aria-label="Remove item"
                                            style="display: none;">
                                        Remove
                                    </button>
                                </div>
                            </div>
                        </div>
                    `;
                });
                itemsContainer.innerHTML = itemsHTML;
            }

            // Update footer section
            const footerContainer = document.getElementById('CartDrawerFooter');
            if (footerContainer) {
                if (cart.item_count > 0) {
                    footerContainer.innerHTML = `
                        <div class="cart-drawer__subtotal">
                            <span>Subtotal</span>
                            <span>${this.formatMoney(cart.total_price)}</span>
                        </div>
                        <form action="/cart" method="post" id="CartDrawer-Form">
                            <button type="submit" name="checkout" class="cart-drawer__checkout">
                                Checkout
                            </button>
                        </form>
                        <p class="cart-drawer__disclaimer">Shipping & taxes calculated at checkout</p>
                    `;
                } else {
                    footerContainer.innerHTML = '';
                }
            }

            // Update header cart count
            this.updateCartCount();

            // Check all inputs and toggle remove buttons
            this.updateAllRemoveButtons();
        } catch (error) {
            console.error('Error refreshing cart drawer:', error);
        }
    }

    formatMoney(cents) {
        // Simple GBP formatter - adjust currency as needed
        return '£' + (cents / 100).toFixed(2);
    }

    toggleRemoveButton(input) {
        const key = input.dataset.key;
        const quantity = parseInt(input.value) || 0;
        const removeBtn = this.drawer.querySelector(`.cart-drawer-quantity__remove-btn[data-key="${key}"]`);
        const plusBtn = this.drawer.querySelector(`.cart-drawer-quantity__button.plus[data-key="${key}"]`);
        const minusBtn = this.drawer.querySelector(`.cart-drawer-quantity__button.minus[data-key="${key}"]`);

        if (removeBtn) {
            if (quantity === 0) {
                removeBtn.style.display = 'block';
                if (plusBtn) plusBtn.style.display = 'none';
                if (minusBtn) minusBtn.style.display = 'none';
            } else {
                removeBtn.style.display = 'none';
                if (plusBtn) plusBtn.style.display = 'flex';
                if (minusBtn) minusBtn.style.display = 'flex';
            }
        }
    }

    updateAllRemoveButtons() {
        const inputs = this.drawer.querySelectorAll('.cart-drawer-quantity__input');
        inputs.forEach(input => this.toggleRemoveButton(input));
    }

    async changeQuantity(key, change) {
        try {

            // Find the input field and update it immediately for better UX
            const input = this.drawer.querySelector(`input[data-key="${key}"]`);
            if (!input) {
                console.error('Input not found for key:', key);
                return;
            }

            const currentQty = parseInt(input.value) || 0;
            const newQty = Math.max(0, currentQty + change);


            // Update input immediately for instant feedback
            input.value = newQty;

            // Toggle remove button visibility
            this.toggleRemoveButton(input);

            // Add loading state
            const buttons = this.drawer.querySelectorAll(`button[data-key="${key}"]`);
            buttons.forEach(btn => btn.disabled = true);

            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: key,
                    quantity: newQty
                })
            });

            if (response.ok) {
                const updatedCart = await response.json();
                await this.refresh();
            } else {
                const errorText = await response.text();
                console.error('Failed to update quantity:', response.status, errorText);
                // Revert the input value on error
                input.value = currentQty;
                alert('Failed to update quantity. Please try again.');
            }

            // Re-enable buttons
            buttons.forEach(btn => btn.disabled = false);
        } catch (error) {
            console.error('Error changing quantity:', error);
            // Try to revert on error
            const input = this.drawer.querySelector(`input[data-key="${key}"]`);
            if (input) {
                const currentQty = parseInt(input.value) - change;
                input.value = Math.max(0, currentQty);
            }
            alert('An error occurred. Please try again.');
        }
    }

    async removeItem(key) {
        try {

            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    id: key,
                    quantity: 0
                })
            });

            if (response.ok) {
                await this.refresh();
            } else {
                console.error('Failed to remove item:', response.status);
            }
        } catch (error) {
            console.error('Error removing item:', error);
        }
    }

    updateCartCount() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                const cartCountElements = document.querySelectorAll('.header__cart-count, #cart-count');
                cartCountElements.forEach(el => {
                    el.textContent = cart.item_count;
                });
            })
            .catch(error => console.error('Error updating cart count:', error));
    }
}

// Initialize cart drawer when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    window.cartDrawer = new CartDrawer();
});

// Global function to open cart drawer
window.openCartDrawer = function () {
    if (window.cartDrawer) {
        window.cartDrawer.open();
    } else {
        // Fallback if not initialized yet
        const drawer = document.getElementById('CartDrawer');
        const overlay = document.getElementById('CartDrawerOverlay');
        if (drawer && overlay) {
            drawer.classList.add('active');
            overlay.classList.add('active');
            document.body.style.overflow = 'hidden';
        }
    }
};
